<template>
  <v-container>
    <v-card flat class="mb-4">
      <v-breadcrumbs divider="/">
        <!-- TODO: Breadcrumbs must be passed as an array, not like this -->
        <v-breadcrumbs-item disabled="True">
          {{ project.Project }}
        </v-breadcrumbs-item>
        <v-breadcrumbs-item> # {{ issue.IID }} </v-breadcrumbs-item>
      </v-breadcrumbs>

      <v-list-item two-line>
        <v-list-item-action>
          <v-chip
            class="ma-2 chip-label"
            text-color="white"
            label
            :color="labelColor(issue.Severity)"
          >
            {{ labelText(issue.Severity) }}
          </v-chip>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="text-h5">
            {{ issue.Title }}
          </v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
                <v-btn outlined color="#006400" @click="snackbar_visible = true"
            >Accept Risk</v-btn>
            </v-list-item-action>
        <v-list-item-action>
          <v-btn outlined @click="snackbar_visible = true"
            >False Positive</v-btn>
        </v-list-item-action>
      </v-list-item>
    </v-card>

    <v-row>
      <v-col cols="12" md="8" sm="12">
        <v-card flat class="mx-auto">
          <v-expansion-panels v-model="panel" multiple flat>
            <v-expansion-panel flat multiple>
              <v-expansion-panel-header ripple class="text-h6"
                >Details</v-expansion-panel-header
              >
              <v-expansion-panel-content>
                <v-row>
                  <v-col cols="4" class="grey--text"> State: </v-col>
                  <v-col cols="8">
                    <v-icon x-small color="green">mdi-circle</v-icon>
                    {{ issue.State }}
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="4" class="grey--text"> Category: </v-col>
                  <v-col cols="8">
                    {{ issue.Category }}
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="4" class="grey--text"> Vector: </v-col>
                  <v-col cols="8">
                    {{ issue.Vector }}
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="4" class="grey--text"> Privilege: </v-col>
                  <v-col cols="8">
                    {{ issue.Privilege }}
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="4" class="grey--text"> Complexity: </v-col>
                  <v-col cols="8">
                    {{ issue.Complexity }}
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="4" class="grey--text"> Impact: </v-col>
                  <v-col cols="8">
                    {{ issue.Impact }}
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel flat multiple>
              <v-expansion-panel-header ripple class="text-h6"
                >Description</v-expansion-panel-header
              >
              <v-expansion-panel-content>
                <v-row>
                  <v-col cols="4" class="grey--text"> Risk: </v-col>
                  <v-col cols="8">
                    {{ issue.Attack }}
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="4" class="grey--text">
                    Adversary Requirements:
                  </v-col>
                  <v-col cols="8">
                    <!-- Use bullets if array length gt 1 -->
                    <div v-if="issue.Requirements.length > 1">
                      <ul>
                        <li
                          v-for="(item, index) in issue.Requirements"
                          :key="index"
                        >
                          {{ item }}
                        </li>
                      </ul>
                    </div>
                    <div v-else>
                      {{ issue.Requirements[0] }}
                    </div>
                  </v-col>
                </v-row>

                <!-- <v-row>
                  <v-col cols="4" class="grey--text">
                    Possible Remediations:
                  </v-col>
                  <v-col cols="8">
                    <div v-if="issue.Actions.length > 1">
                      <ul>
                        <li v-for="(item, index) in issue.Actions" :key="index">
                          {{ item }}
                        </li>
                      </ul>
                    </div>
                    <div v-else>
                      {{ issue.Actions[0] }}
                    </div>
                  </v-col>
                </v-row> -->
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel flat multiple>
              <v-expansion-panel-header ripple class="text-h6"
                >Activity</v-expansion-panel-header
              >
              <v-expansion-panel-content>
                <v-timeline dense>
                  <v-slide-x-reverse-transition group hide-on-leave>
                    <v-timeline-item
                      v-for="item in issue.History"
                      :key="item.timestamp"
                      color="info"
                      small
                      fill-dot
                    >
                      <span class="blue--text">{{ formatDate(item.timestamp) }}:</span> {{ item.detail }}
                    </v-timeline-item>
                  </v-slide-x-reverse-transition>
                </v-timeline>
                        <v-form>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="message"
                    :append-outer-icon="message ? 'mdi-send' : ''"
                    :prepend-icon="icon"
                    filled
                    clear-icon="mdi-close-circle"
                    clearable
                    label="Comments disabled in demo"
                    type="text"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card>

      </v-col>

      <v-col cols="12" md="4">
        <v-card flat class="mx-auto">
          <v-card-title class="text-h6">Info</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="6" class="grey--text"> Created: </v-col>
              <v-col>
                {{ formatDate(issue.Date) }}
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="6" class="grey--text"> Detector: </v-col>
              <v-col>
                {{ issue.Detector }}
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="6" class="grey--text"> Assigned to: </v-col>
              <v-col> Demo User 2 </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <!-- demo toast -->
    <v-snackbar
      color="error"
      v-model="snackbar_visible"
      :timeout="snackbar_timeout"
    >
      {{ snackbar_text }}
      <template v-slot:action="{ attrs }">
        <v-btn
          plain
          snackbar_text
          v-bind="attrs"
          @click="snackbar_visible = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import { getLabelColor, getLabelText } from "../common/Labels.js";
import { demoData } from "../a9n-testdata.js";
import { DateTime } from "luxon";

export default {
  data: () => ({
    snackbar_visible: false,
    snackbar_text: "Demo instance - functionality disabled",
    snackbar_timeout: 2000,
    panel: [0, 1, 2], // expanded panels
  }),
  methods: {
    labelColor(str) {
      return getLabelColor(str);
    },
    labelText(str) {
      return getLabelText(str);
    },
    formatDate(secs) {
      return DateTime.fromSeconds(secs)
        .setLocale("en-GB")
        .toLocaleString(DateTime.DATE_MED);
    },
  },
  computed: {
    project() {
      return demoData.Projects[this.$route.params.assessmentId - 1];
    },
    issue() {
      return demoData.Projects[this.$route.params.assessmentId - 1].Issues[
        this.$route.params.issueId - 1
      ];
    },
  },
};
</script>
<style>
.chip-label {
  width: 80px;
  font-weight: bold;
  justify-content: center;
}
</style>
